import { useEffect } from "react";
import PageTitle from "@/components/site/PageTitle";
import Hero from "@/components/site/Hero";
import KineticMarquee from "@/components/site/KineticMarquee";
import ProgramsGrid from "@/components/site/ProgramsGrid";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import ProductsGrid from "@/components/site/ProductsGrid";
import ServicesSection from "@/components/site/ServicesSection";
import IndustryExposure from "@/components/site/IndustryExposure";
import PartnersSection from "@/components/site/PartnersSection";
import Testimonials from "@/components/site/Testimonials";
import CTASection from "@/components/site/CTASection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <PageTitle title="" />
      <Hero />
      <KineticMarquee />
      <ProgramsGrid />
      <ServicesSection />
      <IndustryExposure />
      <PartnersSection />
      <CTASection />
    </main>
  );
}
